module.exports = __webpack_public_path__ + "img/mapa-lambdas.81df6706.png";